<template>
  <div>
    <b-card class="bg-white">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Sales Report
          </h2>

          <small class=" text-muted ">PERFORMANCE </small>
        </div>
      </div>

      <div class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-4  gap-8 mt-12 ">
        <b-card
          v-for="(item, index) in reports"
          :key="'item-' + index"
          :style="{ background: `${item.color}` }"
        >
          <h2 class="font-bold text-lg text-white">${{ item.number }}</h2>
          <p class="font-normal text-white">{{ item.status }}</p>
        </b-card>
      </div>
      <div class="chart  mt-12">
        <bar-chart
          :height="350"
          ref="barChart"
          :chart-data="redBarChart.chartData"
        >
        </bar-chart>
      </div>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import * as config from "../sales-report/barChart/Config";
import BarChart from "../sales-report/barChart/Barchart";
export default {
  data() {
    return {
      reports: [
        {
          number: "000",
          status: "Total Order",
          color: "#11cdef"
        },
        {
          number: "000",
          status: "Total Order",
          color: "#5e72e4"
        },
        {
          number: "000",
          status: "Total Order",
          color: "#f5365c"
        },
        {
          number: "000",
          status: "Total Order",
          color: "#fb6340"
        }
      ],
      redBarChart: {
        chartData: {
          labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29]
            }
          ]
        },
        extraOptions: config.blueChartOptions
      }
    };
  },
  components: {
    BarChart,
    config
  }
};
</script>
